import PageHeader from "../components/PageHeader";
import ExperiencesSection from "../components/ExperiencesSection";
import ContactCTA from "../components/ContactCTA";

export default function Experiences() {
  return (
    <div data-testid="page-experiences">
      <PageHeader
        overline="Nos vols"
        title="Bien plus qu'un vol, "
        italicWord="une expérience inoubliable."
        lead="Baptême de l'air, initiation au pilotage, vols mariage, restaurant et transport VIP — chaque mission est pensée sur mesure. Tarifs publics ou devis dédié."
      />
      <ExperiencesSection />
      <ContactCTA />
    </div>
  );
}
